import React, { FC, Fragment, useState } from 'react';
import { Grid, Paper, Tab, Tabs, Typography } from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import SubjectRoundedIcon from '@material-ui/icons/SubjectRounded';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { PaddedPaper } from 'components';
import { useCurrentUser } from 'hooks';

import styles from './styles';
import GroupSelect from '../components/GroupSelect';
import LinkForm from '../components/Link/LinkForm';
import TextForm from '../components/Text/TextForm';
import { Commentary } from '../components/widgets';
import FormButtons from '../components/FormButtons';
import ImageVideoForm from '../components/ImageVideo/ImageVideoForm';
import { isContributorAndAbove, isModeratorAndAbove } from '../helpers';
import PinPost from '../components/widgets/PinPost';
import NotifyTeam from '../components/widgets/NotifyTeam';

const useStyles = makeStyles(styles);

const Post: FC = ({ children }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const user = useCurrentUser();

  const [tabValue, setTabValue] = useState(0);

  function renderTabs() {
    return (
      <Tabs
        value={tabValue}
        onChange={(e, value: number) => setTabValue(value)}
        textColor="primary"
        indicatorColor="primary"
        variant="fullWidth">
        <Tab
          classes={{ wrapper: classes.wrapper, root: classes.root }}
          label={
            <Fragment>
              <LinkIcon className={classes.tab} />
              {t('common:link_plural')}
            </Fragment>
          }
        />
        <Tab
          classes={{ wrapper: classes.wrapper, root: classes.root }}
          label={
            <Fragment>
              <AddPhotoAlternateIcon className={classes.tab} />
              {t('common:imageAndVideo')}
            </Fragment>
          }
        />
        <Tab
          classes={{ wrapper: classes.wrapper }}
          label={
            <Fragment>
              <SubjectRoundedIcon className={classes.tab} />
              {t('common:Text')}
            </Fragment>
          }
        />
      </Tabs>
    );
  }

  return (
    <Grid container alignItems="flex-start" direction="column" spacing={2}>
      <Grid item xs>
        <Typography variant="h4">{t('posting:createPost')}</Typography>
      </Grid>

      <Grid container item xs={5}>
        <GroupSelect />
      </Grid>

      <Grid item xs container>
        <Paper variant="outlined" square className={classes.paper}>
          {renderTabs()}
        </Paper>
        <PaddedPaper square className={classes.container}>
          {tabValue === 0 && <LinkForm />}
          {tabValue === 1 && <ImageVideoForm />}
          {tabValue === 2 && <TextForm />}
        </PaddedPaper>
      </Grid>

      {isModeratorAndAbove(user) && (
        <Grid item xs container>
          <NotifyTeam />
        </Grid>
      )}

      {isModeratorAndAbove(user) && (
        <Grid item xs container>
          <PinPost />
        </Grid>
      )}

      {isContributorAndAbove(user) && (
        <Grid item xs container>
          <Commentary />
        </Grid>
      )}

      {children}

      <FormButtons />
    </Grid>
  );
};

export default Post;
